import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Router, Route, IndexRoute, hashHistory } from 'react-router';
import App from './components/App';
import Home from './components/pages/Home';
import Checklist from './components/pages/Checklist';
import Success from './components/pages/Success';

import './index.css';

ReactGA.initialize('UA-76692344-1');

function logPageView() {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const routes = (
    <Router history={hashHistory} onUpdate={logPageView}>
      <Route path="/" component={App}>
        <IndexRoute component={Home}/>
        <Route path="/checklist" component={Checklist}/>
        <Route path="/success" component={Success}/>
      </Route>
    </Router>
);

ReactDOM.render(routes, document.getElementById('root'));



// WEBPACK FOOTER //
// src/index.js